export class SortSnapshotsBy {
    'field';
    'order';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "SnapshotSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortSnapshotsBy.attributeTypeMap;
    }
    constructor() {
    }
}
